import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { interval: { type: Number, default: 5000 } }

  connect() {
    this.startFlipping()
  }

  disconnect() {
    this.stopFlipping()
  }

  startFlipping() {
    this.flipInterval = setInterval(() => {
      this.element.classList.toggle('flipped')
    }, this.intervalValue)
  }

  stopFlipping() {
    if (this.flipInterval) {
      clearInterval(this.flipInterval)
    }
  }
}
